import { FormattedMessage } from 'react-intl';

import type { featuresTableProps } from '@xing-com/crate-premium-projobs-shared-features-overview';
import {
  FeaturesOverview,
  useProJobsData,
} from '@xing-com/crate-premium-projobs-shared-features-overview';
import { Hero } from '@xing-com/typography';
import { Column, Grid, Row } from '@xing-com/xing-grid';

export const ProjobsFeaturesOverview: React.FC = () => {
  const { data } = useProJobsData();
  const featuresTableHeaders = [
    <span key="Premium" aria-hidden="true">
      Premium
    </span>,
    <span key="projobs" aria-label="Projobs benefits">
      ProJobs
    </span>,
  ];
  const featuresTable = data?.viewer?.premiumFeaturesOverview?.collection;
  if (!featuresTable || !data?.viewer?.premiumFeaturesOverview) {
    return null;
  }

  return (
    <Grid>
      <Column size={12}>
        <Row>
          <Hero>
            <FormattedMessage id={'PROJOBS_FEATURES_OVERVIEW_HEADER_BASIC'} />
          </Hero>
        </Row>
        <FeaturesOverview
          featuresTableHeaders={featuresTableHeaders}
          //eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          featuresTable={featuresTable as featuresTableProps}
        />
      </Column>
      <Column size={12} sizeConfined={11} sizeXWide={9}></Column>
    </Grid>
  );
};
